/* =========================================================
   ELYRIUM Shopify theme · interactions (vanilla JS)
   ========================================================= */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

/* ---------- Nav: scrolled state + mobile menu ---------- */
const nav = document.getElementById('nav');
const toggle = document.getElementById('navToggle');
const links = document.getElementById('navLinks');
const setMenu = (open) => {
  toggle.setAttribute('aria-expanded', String(open));
  toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  links.classList.toggle('is-open', open);
  document.body.style.overflow = open ? 'hidden' : '';
};
toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
links.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setMenu(false); });

/* ---------- Hero: SplitText ---------- */
let charIndex = 0;
document.querySelectorAll('[data-split]').forEach((el) => {
  const text = el.textContent;
  el.textContent = '';
  el.setAttribute('aria-hidden', 'true');
  [...text].forEach((ch) => {
    const s = document.createElement('span');
    s.className = 'char';
    s.textContent = ch;
    s.style.setProperty('--i', charIndex++);
    el.appendChild(s);
  });
});

/* ---------- ScrollFloat: split H2s into words ---------- */
document.querySelectorAll('.float-words').forEach((h) => {
  let i = 0;
  const wrap = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === 3) {
        const frag = document.createDocumentFragment();
        child.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
          const w = document.createElement('span'); w.className = 'w';
          const inner = document.createElement('span'); inner.textContent = part;
          inner.style.setProperty('--i', i++);
          w.appendChild(inner); frag.appendChild(w);
        });
        child.replaceWith(frag);
      } else if (child.nodeType === 1) wrap(child);
    });
  };
  wrap(h);
});

/* ---------- Reveal on scroll ---------- */
const revealEls = document.querySelectorAll('.reveal, .float-words');
if (reduceMotion || !('IntersectionObserver' in window)) {
  revealEls.forEach((el) => el.classList.add('is-in'));
} else {
  // stagger siblings inside the same parent
  const groups = new Map();
  document.querySelectorAll('.reveal').forEach((el) => {
    const g = groups.get(el.parentElement) || 0;
    el.style.setProperty('--d', `${Math.min(g, 5) * 0.09}s`);
    groups.set(el.parentElement, g + 1);
  });
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  revealEls.forEach((el) => io.observe(el));
}

/* ---------- Petals (hero background) ---------- */
const petals = document.querySelector('[data-petals]');
if (!reduceMotion && petals) {
  const count = window.innerWidth < 700 ? 10 : 18;
  for (let i = 0; i < count; i++) {
    const p = document.createElement('span');
    p.className = 'petal' + (i % 3 === 0 ? ' petal--gold' : '');
    p.style.left = `${Math.random() * 100}%`;
    p.style.setProperty('--s', `${8 + Math.random() * 12}px`);
    p.style.setProperty('--d', `${12 + Math.random() * 12}s`);
    p.style.setProperty('--delay', `${-Math.random() * 20}s`);
    p.style.setProperty('--x', `${(Math.random() - 0.5) * 240}px`);
    petals.appendChild(p);
  }
}

/* Pause hero animations off-screen */
const hero = document.querySelector('.hero');
if (hero && 'IntersectionObserver' in window) {
  new IntersectionObserver(([en]) => hero.classList.toggle('is-paused', !en.isIntersecting)).observe(hero);
}

/* ---------- Videos: play only while visible ---------- */
document.querySelectorAll('video.film__video, video.ritual__video').forEach((v) => {
  v.muted = true; v.playsInline = true; v.removeAttribute('autoplay');
  if (reduceMotion) return; // poster only
  new IntersectionObserver(([en]) => {
    if (en.isIntersecting) v.play().catch(() => {});
    else v.pause();
  }, { threshold: 0.2 }).observe(v);
});

/* ---------- Scroll loop: nav, parallax, film expand, footer thanks ---------- */
const parallaxEls = [...document.querySelectorAll('[data-parallax]')];
const filmFrame = document.querySelector('[data-film]');
const thanks = document.getElementById('thanks');
let ticking = false;

function onScroll() {
  const y = window.scrollY;
  const vh = window.innerHeight;
  nav.classList.toggle('is-scrolled', y > 24);

  if (!reduceMotion) {
    parallaxEls.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      const center = r.top + r.height / 2 - vh / 2;
      el.style.translate = `0 ${(center * parseFloat(el.dataset.parallax)).toFixed(1)}px`;
    });

    if (filmFrame && window.innerWidth >= 700) {
      const r = filmFrame.getBoundingClientRect();
      // 0 when the frame's top reaches the bottom of the viewport → 1 when it's 15% from the top
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.85)));
      filmFrame.style.setProperty('--p', p.toFixed(3));
    }
  }

  const atBottom = vh + y >= document.documentElement.scrollHeight - 40;
  if (thanks) thanks.classList.toggle('is-visible', atBottom);
  ticking = false;
}
window.addEventListener('scroll', () => {
  if (!ticking) { requestAnimationFrame(onScroll); ticking = true; }
}, { passive: true });
window.addEventListener('resize', onScroll);
onScroll();

/* ---------- Pointer effects (desktop only) ---------- */
if (finePointer && !reduceMotion) {
  // Tilt + glare on product cards
  document.querySelectorAll('.tilt').forEach((card) => {
    let raf = 0;
    card.addEventListener('pointermove', (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width;
        const y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--ry', `${(x - 0.5) * 8}deg`);
        card.style.setProperty('--rx', `${(0.5 - y) * 6}deg`);
        card.style.setProperty('--mx', `${x * 100}%`);
        card.style.setProperty('--my', `${y * 100}%`);
      });
    });
    card.addEventListener('pointerleave', () => {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  });

  // Spotlight on bento tiles
  document.querySelectorAll('.spotlight').forEach((tile) => {
    let raf = 0;
    tile.addEventListener('pointermove', (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = tile.getBoundingClientRect();
        tile.style.setProperty('--mx', `${e.clientX - r.left}px`);
        tile.style.setProperty('--my', `${e.clientY - r.top}px`);
      });
    });
  });

  // Magnetic CTAs
  document.querySelectorAll('.magnet').forEach((btn) => {
    let raf = 0;
    btn.addEventListener('pointermove', (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const r = btn.getBoundingClientRect();
        const dx = e.clientX - (r.left + r.width / 2);
        const dy = e.clientY - (r.top + r.height / 2);
        btn.style.translate = `${dx * 0.18}px ${dy * 0.28}px`;
      });
    });
    btn.addEventListener('pointerleave', () => { btn.style.translate = '0 0'; });
  });
}

/* ---------- ClickSpark: gold sparks on CTAs ---------- */
function sparkAt(x, y, n = 10) {
  if (reduceMotion) return;
  for (let i = 0; i < n; i++) {
    const s = document.createElement('span');
    s.className = 'spark';
    const a = (Math.PI * 2 * i) / n;
    const d = 28 + Math.random() * 18;
    s.style.left = `${x - 3}px`;
    s.style.top = `${y - 3}px`;
    s.style.setProperty('--tx', `${Math.cos(a) * d}px`);
    s.style.setProperty('--ty', `${Math.sin(a) * d}px`);
    document.body.appendChild(s);
    s.addEventListener('animationend', () => s.remove());
  }
}
document.querySelectorAll('[data-spark]').forEach((el) => {
  el.addEventListener('click', (e) => sparkAt(e.clientX, e.clientY));
});

/* ---------- Hidden detail: footer emblem petal burst ---------- */
const emblem = document.getElementById('footerEmblem');
if (emblem) emblem.addEventListener('click', () => {
  if (reduceMotion) return;
  const r = emblem.getBoundingClientRect();
  const cx = r.left + r.width / 2;
  const cy = r.top + r.height / 2;
  for (let i = 0; i < 16; i++) {
    const p = document.createElement('span');
    p.className = 'burst-petal';
    p.style.left = `${cx}px`;
    p.style.top = `${cy}px`;
    const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.2;
    const d = 80 + Math.random() * 140;
    p.style.setProperty('--tx', `${Math.cos(a) * d}px`);
    p.style.setProperty('--ty', `${Math.sin(a) * d}px`);
    p.style.setProperty('--r', `${Math.random() * 540}deg`);
    document.body.appendChild(p);
    p.addEventListener('animationend', () => p.remove());
  }
});

/* =========================================================
   Bundle option cards: update the price shown at the bottom
   ========================================================= */
const fmt = (cents) => (Number(cents) / 100).toFixed(2);
document.querySelectorAll('.product-card__form').forEach((form) => {
  const priceEl = form.querySelector('[data-card-price]');
  form.querySelectorAll('input[name="id"]').forEach((input) => {
    input.addEventListener('change', () => {
      const cur = priceEl.querySelector('.price__cur');
      const compare = Number(input.dataset.compare);
      priceEl.innerHTML = `${cur ? cur.outerHTML : ''} ${fmt(input.dataset.price)}${compare > Number(input.dataset.price) ? ` <s class="price__was">${fmt(compare)}</s>` : ''}`;
    });
  });
});

/* Product page: quantity stepper + variant price */
document.querySelectorAll('[data-qty-step]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, Math.min(99, Number(input.value || 1) + Number(btn.dataset.qtyStep)));
  });
});
document.querySelectorAll('[data-variant-select]').forEach((sel) => {
  sel.addEventListener('change', () => {
    const opt = sel.selectedOptions[0];
    const priceEl = document.querySelector('[data-pdp-price]');
    if (!priceEl) return;
    const cur = priceEl.querySelector('.price__cur');
    const compare = parseFloat(opt.dataset.compare || 0);
    priceEl.innerHTML = `${cur ? cur.outerHTML : ''} ${opt.dataset.price}${compare > parseFloat(opt.dataset.price) ? ` <s class="price__was">${opt.dataset.compare}</s>` : ''}`;
  });
});

/* =========================================================
   Shopify cart drawer (AJAX API + Section Rendering)
   ========================================================= */
const routes = (window.Elyrium && window.Elyrium.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
const drawer = document.getElementById('cartDrawer');
const overlay = document.getElementById('cartOverlay');
const openBtn = document.getElementById('cartOpen');
const countEl = document.getElementById('cartCount');
const toast = document.getElementById('toast');
let lastFocus = null;
let toastTimer = 0;

function showToast(text) {
  if (!toast) return;
  toast.textContent = text;
  toast.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
}

function setCount(n) {
  if (!countEl) return;
  countEl.textContent = n;
  countEl.classList.toggle('is-visible', n > 0);
  openBtn && openBtn.setAttribute('aria-label', `Open cart, ${n} item${n === 1 ? '' : 's'}`);
}

function renderDrawer(html) {
  if (!html || !drawer) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = doc.getElementById('cartDrawerInner');
  const current = document.getElementById('cartDrawerInner');
  if (fresh && current) {
    current.replaceWith(fresh);
    setCount(Number(fresh.dataset.count || 0));
  }
}

function setCartOpen(open) {
  if (!drawer) return;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  openBtn && openBtn.setAttribute('aria-expanded', String(open));
  overlay.hidden = !open;
  requestAnimationFrame(() => overlay.classList.toggle('is-open', open));
  document.body.style.overflow = open ? 'hidden' : '';
  if (open) {
    lastFocus = document.activeElement;
    toast && toast.classList.remove('is-visible');
    const close = drawer.querySelector('[data-cart-close]');
    close && close.focus();
  } else if (lastFocus) lastFocus.focus();
}

async function cartRequest(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: window.location.pathname }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
  return data;
}

// Add to cart (all forms marked data-add-form). Without JS the form still posts to /cart/add.
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('[data-add-form]');
  if (!form || !drawer) return;
  e.preventDefault();
  const fd = new FormData(form);
  const id = fd.get('id');
  const quantity = Number(fd.get('quantity') || 1);
  const btn = form.querySelector('[type="submit"]');
  if (!id) return;
  btn && btn.setAttribute('aria-busy', 'true');
  try {
    const data = await cartRequest(`${routes.cart_add_url}.js`, { items: [{ id: Number(id), quantity }] });
    renderDrawer(data.sections && data.sections['cart-drawer']);
    setCartOpen(true);
    if (countEl) { countEl.classList.remove('is-bump'); void countEl.offsetWidth; countEl.classList.add('is-bump'); }
  } catch (err) {
    showToast(err.message);
  } finally {
    btn && btn.removeAttribute('aria-busy');
  }
});

// Quantity / remove inside the drawer
if (drawer) {
  drawer.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-close]')) { setCartOpen(false); return; }
    const b = e.target.closest('[data-line-key]');
    if (!b) return;
    e.preventDefault();
    try {
      const data = await cartRequest(`${routes.cart_change_url}.js`, { id: b.dataset.lineKey, quantity: Number(b.dataset.lineQty) });
      renderDrawer(data.sections && data.sections['cart-drawer']);
      const close = drawer.querySelector('[data-cart-close]');
      close && close.focus();
    } catch (err) { showToast(err.message); }
  });
}
if (openBtn && drawer) {
  openBtn.addEventListener('click', (e) => { e.preventDefault(); setCartOpen(true); });
}
overlay && overlay.addEventListener('click', () => setCartOpen(false));
document.addEventListener('keydown', (e) => {
  if (!drawer || !drawer.classList.contains('is-open')) return;
  if (e.key === 'Escape') setCartOpen(false);
  if (e.key === 'Tab') {
    const f = [...drawer.querySelectorAll('button, a[href]')].filter((el) => el.offsetParent);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
});
